import React from 'react';
import ReactDOM from 'react-dom/client';
import { PrimeReactProvider } from 'primereact/api';
import { setupGridLocale } from '@inuxe/prime-odata-grid';

import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

import 'primereact/resources/themes/lara-light-blue/theme.css';
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';
import '@inuxe/common-popup/styles';
import '@inuxe/common-button/styles';
import '@inuxe/formik-components/styles';
import '@inuxe/prime-odata-grid/styles';

setupGridLocale('tr');

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

root.render(
  <React.StrictMode>
    <PrimeReactProvider value={{ locale: 'tr' }}>
      <App />
    </PrimeReactProvider>
  </React.StrictMode>
);

reportWebVitals();
